<template>

    <AppHeaderDropdown right class="mr-2">
        <template slot="header">
            <i class="icon-user"></i>
            <span class="d-none d-sm-inline-block">
                &nbsp;{{userInfo.FullName}}
            </span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item @click="logout"><i class="fa fa-sign-out" /> <b>Logout </b> {{userInfo.FullName}} {{isAdmin}}</b-dropdown-item>
        </template>
    </AppHeaderDropdown>

</template>
<script>
    import { mapGetters } from 'vuex'
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

    export default {
        name: 'DefaultHeaderDropdown',
        components: {
            AppHeaderDropdown
        },
        data: () => {
            return {
                periods: [],
                companies: [],
            }
        },
        created() {

            this.$store.dispatch('user/userRequest')
                .catch((err) => {
                    this.$router.push( { name: 'Login' });
                });
        },
        computed:
        {
            ...mapGetters(
                {
                    userInfo: 'user/profile',

                }),
            isAdmin() {
                return this.$store.getters['user/profile'].IsAdmin ? '[adm]' : '';
            }
        },
        methods:
        {
            logout() {
                var model = this;
                this.$store.dispatch('auth/authLogout')
                    .then((result) => {
                        model.$router.push({ name: 'Login' });
                    })
                    .catch((err) => {
                        showErrorNotification(err);
                    });;
            },

        }
    }
</script>
